module.exports = __webpack_public_path__ + "static/media/apng_weak_green.72538946.png";